import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/servicePage.js";

// Sections for this page
import PriceListing from "./Sections/PriceListing";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function ThreadPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const items = [
    {name: "Eyebrows", price: "$5"},
    {name: "Upper Lip", price: "$4"},
    {name: "Lower Lip", price: "$3"},
    {name: "Chin", price: "$4"},
    {name: "Forehead", price: "$4"},
    {name: "Neck", price: "$7"},
    {name: "Side Face", price: "$7"},
    {name: "Full Face", price: "$25"}
  ]
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand="Lili's Waxing and Threading Studio"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/thread.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Threading</h1>
              <h4>
                Threading has been around for centuries, and it is one of the most effective ways of
                getting rid of unwated hair with the least pain. Hairs take longer to grow back once removed by thread since
                the hairs are removed from their roots. Threading is the best way to shape eyebrows and remove hair from the upper lip and chin.
              </h4>
              <br />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <PriceListing products={items}/>
        </div>
      </div>
      <Footer />
    </div>
  );
}
